import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppSettingsService } from '../../appsettings/appsettings.service';

@Injectable()
export class PatientService
{	
	readonly rootUrl = environment.ProNetApiRootUrl;
	
	constructor(private httpClient: HttpClient, env: AppSettingsService) { 
		this.rootUrl = env.config.ProNetApiRootUrl; }
		
	getMyPatients(patientLastName, patientDOB, patientSSN) : Observable<any>{
		console.log("getting recent test orders");
		const body= {
			patientName: patientLastName,
			patientDOB: patientDOB,
			patientSSN: patientSSN
		}

		return this.httpClient.post(`${this.rootUrl}/api/patient/mypatients`, body);
	}
}
